import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Tooltip } from '@beef/ui-kit';
import { Picture } from "../../../Picture";
import { NumbersSharing } from "../NumbersSharing";
import { getCompactParameterPictureSrc } from "../../utils";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
var CompactParameterWithTooltip = function CompactParameterWithTooltip(_ref) {
  var compactParameter = _ref.compactParameter,
    isFirst = _ref.isFirst,
    isYandex = _ref.isYandex,
    children = _ref.children;
  if (compactParameter !== null && compactParameter !== void 0 && compactParameter.value && compactParameter.value.trim()) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      message: compactParameter.value,
      position: isFirst ? 'right' : 'top',
      variant: "secondary",
      "data-t-id": "components-CompactParameter"
    }, /*#__PURE__*/React.createElement("div", {
      className: cn({
        'tooltip-wrapper': isYandex
      }),
      "data-t-id": "components-CompactParameter"
    }, children));
  }
  return children;
};
export var CompactParameter = /*#__PURE__*/memo(function (_ref2) {
  var isLast = _ref2.isLast,
    isFirst = _ref2.isFirst,
    isYandex = _ref2.isYandex,
    cardType = _ref2.cardType,
    isSharing = _ref2.isSharing,
    badgeClassName = _ref2.badgeClassName,
    compactParameter = _ref2.compactParameter;
  return /*#__PURE__*/React.createElement(CompactParameterWithTooltip, {
    compactParameter: compactParameter,
    isFirst: isFirst,
    isYandex: isYandex
  }, isSharing ? /*#__PURE__*/React.createElement(NumbersSharing, {
    badgeClassName: badgeClassName,
    cardType: cardType,
    compactParameter: compactParameter,
    isLast: isLast
  }) : /*#__PURE__*/React.createElement(Picture, {
    alt: compactParameter.value,
    lazy: true,
    src: getCompactParameterPictureSrc(compactParameter)
  }));
});